import React from "react";
import { withRouter, Link } from "react-router-dom";
import Icon from "../../shared/Icon";
import addChildIcon from "assets/img/icons/icon_child_plus_v02.png";
import childDefaultImage from "assets/img/defaults/profile_default_v01.png";

const styles = {
    display: "inline-block",
    width: "99px",
    height: "30px",
    backgroundSize: "99px 30px",
    textIndent: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden"
};

const MyChildHeader = props => {
    const mysponDonateToken = localStorage.getItem('myspon_donate_token') ?? null
    const addChildURL = `https://myspon-donate.worldvision.org.ph/autologin?token=${mysponDonateToken}&continue=%2Fhome`

    return (
        <div className="donor-header island">
            <div className="child-image">
                <a
                    onClick={props.handler(props.prevChild)}
                    className="arrows arrow-left"
                    href="#next"
                    title={"Previous Child"}
                >
                    <span className="hidden">left</span>
                    <i className="fa fa-chevron-left" aria-hidden="true" />
                </a>
                <Link
                    to={`/dashboard/child/${props.child.child_id}`}
                    title={props.child.given_name}
                    className="child-image-link"
                >
                    <img src={props.childPhoto || childDefaultImage} alt="" />
                </Link>

                {/* {props.childrenCount > 1 && ( */}
                <a
                    onClick={props.handler(props.nextChild)}
                    className="arrows arrow-right"
                    href="#next"
                    title="Next Child"
                >
                    <span className="hidden">right</span>
                    <i className="fa fa-chevron-right" aria-hidden="true" />
                </a>
                {/* )} */}
            </div>

            <h2 className="local-child-greeting">
                Hello, {props.sponsorName}!
                <br className="visible-xs" /> I'm {props.child.given_name}.
                <br className="visible-xs" /> Explore my world!
            </h2>

            <div
                id="block-block-26"
                className="add-child-btn block block-block hidden-xs"
            >
                <a
                    href={addChildURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Sponsor another child"
                >
                    <Icon bgUrl={addChildIcon} styles={styles} />
                    <span className="link-text">Add child</span>
                </a>
            </div>
        </div>
    );
};

MyChildHeader.defaultProps = {
    child: {
        name: ""
    },
    childPhoto: childDefaultImage,
    sponsorName: "Sponsor"
};

export default withRouter(MyChildHeader);
